import { useContext } from 'react'
import { Box, Button, CheckIcon, Hidden } from '@hermes/web-components'
import { BodyMedium, SECTION_WIDTH } from '../styles'
import { Container, CoverImageWrapper, Section, Title, Wrapper } from './styles'
import { getProviderUrl, purifyTenantDomain } from '../../../utils/url'
import { AppDataContext } from '../../../providers/AppData'
import useTranslateMessage from '../../../hooks/useTranslateMessage'
import Image from 'next/image'

const providerFeatures = ['collect', 'validate', 'connect', 'realtime', 'other']

const ProvidersSection = () => {
  const { locale } = useContext(AppDataContext)
  const translate = useTranslateMessage()

  const providerLink = getProviderUrl(locale)

  return (
    <Section sx={{ overflow: 'hidden' }}>
      <Container sx={{ maxWidth: SECTION_WIDTH }}>
        <Wrapper sx={{ maxWidth: '488px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '12px' }}>
            <Title variant="h2">{translate('homepage.search.providers.title')}</Title>
            <BodyMedium sx={{ textAlign: 'start' }}>{translate('homepage.search.providers.subtitle')}</BodyMedium>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '16px' }}>
            {providerFeatures.map((item, key) => (
              <Box key={key} sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <Box
                  style={{
                    borderRadius: '50%',
                    border: 'solid #11245A thin',
                    height: '18px',
                    width: '18px',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <CheckIcon sx={{ color: '#11245A', width: '12px' }} />
                </Box>
                <BodyMedium sx={{ textAlign: 'start' }}>
                  {translate(`homepage.search.providers.feat.${item}`)}
                </BodyMedium>
              </Box>
            ))}
          </Box>

          <Button
            sx={{
              width: 'fit-content',
              borderRadius: '20px',
              color: '#1A3586',
              borderColor: '#1A3586',
              paddingLeft: '10px',
              paddingRight: '10px',
              padding: '8px 24px',
              backgroundColor: '#fff',
              '&:focus': { borderColor: 'transparent', color: '#fff' }
            }}
            href={`${purifyTenantDomain('', locale)}${providerLink}`}
            variant="outlined"
          >
            {translate('homepage.search.providers.learnmore')}
          </Button>
        </Wrapper>
      </Container>
      <CoverImageWrapper>
        <Box component={Hidden} mdDown implementation="css">
          <Image loading="lazy" src="/hermes-static/images/providers-cover.png" alt="Providers Cover" layout="fill" />
        </Box>
        <Box component={Hidden} mdUp implementation="css">
          <Image
            loading="lazy"
            src="/hermes-static/images/providers-cover-mobile.png"
            alt="Providers Cover"
            layout="fill"
          />
        </Box>
      </CoverImageWrapper>
    </Section>
  )
}

export default ProvidersSection
